
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {Obi03TidalStream as Obi03TidalStreamElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-03-tidal-stream.js';
 
 
 

 
 export const Obi03TidalStream = createComponent({
   react: React,
   tagName: 'obi-03-tidal-stream',
   elementClass: Obi03TidalStreamElement,
   events: {
     
   }
  });
 
 